// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1EJ06","select":"Header_select__atEZu","clinic":"Header_clinic__1610P"};